import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/company_certification_variables');
  return response.data.data;
}

async function update(data, id) {
  let response = await axiosAuth.post('/company_certification_variables/' + id, data);
  return response.data.data;
}

export default {
  index,
  update,
};
